import { Gender } from '../general';

export interface IBodyDetails {
  age: number;
  gender: Gender;
  height: number;
  weight: number;
  heartRateMax: number;
}

export interface IHeartRate {
  heartRate: number;
  timestamp: Date;
  source?: string;
  debug?: string;
}

export enum HeartRateZone {
  none = 0,
  zone1 = 1,
  zone2 = 2,
  zone3 = 3,
  zone4 = 4,
  zone5 = 5,
}

export type IMetricResult = {
  type: 'calculated';
} & ICalculatedMetrics & ILatestMetrics;

export interface ICalculatedMetrics {
  averageHeartRate: number;
  averageEffort: number;
  calories: number | undefined;
  load: number;
  calculatedAt: Date;
  latestReadingTimestamp: Date;
  debug: IMetricDebug | undefined;
}

export type ITypeLessMetricResult = (ICalculatedMetrics | undefined) & ILatestMetrics;

export type ILiveMetric = {
  type: 'live';
} & ILatestMetrics;

export interface ILatestMetrics {
  latestHeartRate: number;
  latestHeartRateZone: HeartRateZone;
  latestEffort: number;
}

export interface IMetricDebug {
  totalMinutes: number;
  calculationTime: number;
  timePerHeartRateZone: number[];
  bodyDetails: IBodyDetails;
}
